/* @flow */

import criarUrlImprimirPorPedidosId from './criar-url-imprimir-por-pedidos-id';

const imprimirPorPedidosId = (pedidoId: number) => (
    window.open(
        criarUrlImprimirPorPedidosId(pedidoId),
        '_blank',
    )
);

export default imprimirPorPedidosId;
